import { Component,OnInit } from '@angular/core'
import { PowerOfAttorneyModel } from '../../models/power-of-attorney'
import { FormValidationService } from '../../../validations/form-validation-service'
import { Router, ActivatedRoute } from '@angular/router'
import { UserAccessGateway } from '../../../common/gateways/user-access-gateway'
import { EnrollmentGateway } from '../../gateways/enrollment-gateway'
import { ValidatedRadioButtonModel } from '../../../validations/validated-radio-button-group.component'
import { PortalGlobals } from '../../../portalglobals'


@Component({
    selector: 'terms-of-service',
    templateUrl: './terms-of-service.component.html'

})
export class TermsOfServiceComponent implements OnInit {
    beneficiarySigned: boolean
    powerOfAttormeyModel: PowerOfAttorneyModel = {} as PowerOfAttorneyModel
    poaOptions: ValidatedRadioButtonModel[] = [] as ValidatedRadioButtonModel[] 
    poaOption: string = ""
    showPoaForm: boolean = false
    orgName: string
    constructor(private _enrollmentGateway: EnrollmentGateway,
        private _userAccessGateway: UserAccessGateway,
        private _validationService: FormValidationService,
        private _routers: Router,
        public _global: PortalGlobals
    ) { }


    valueChanged(value: boolean) {
        this.beneficiarySigned = value
    }

    ngOnInit() {
        this.poaOptions = [
            { value: 'No', htmlLabel: 'No' },
            { value: 'Yes', htmlLabel: 'Yes' }
        ]
        this.orgName = this._global.currentUser.insuranceCompanyName
    }

    powOptionChanged(option: string) {
        this.showPoaForm=!this.showPoaForm
    }

    validateForm() {
        const insCo = this._global.currentUser.insuranceCompanyShortName.toLowerCase()
        this._validationService.validateAll(
            () => {
                let url = '/' + insCo + '/enrollment/external-agent'
                this._routers.navigateByUrl(url)
            },
            () => { }
        )
    }
}
